import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Phone } from 'lucide-react';

export default function CTASection() {
  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center relative">
        <p className="eyebrow">Vous avez un projet ?</p>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-5 text-gray-900 leading-[1.05]">
          Une étude personnalisée,<br/>
          <span className="italic-accent">gratuite</span> et sans engagement.
        </h2>
        <p className="mt-6 text-gray-600 max-w-2xl mx-auto">
          Nos experts répondent à vos questions et se déplacent chez vous en Suisse romande pour une étude énergétique personnalisée de votre projet.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact" className="btn-primary inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-sm font-medium">
            Demander un devis <ArrowUpRight className="w-4 h-4" />
          </Link>
          <a href="tel:+41225187155" className="btn-outline inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-sm font-medium">
            <Phone className="w-4 h-4" /> 022 518 71 55
          </a>
        </div>
      </div>
    </section>
  );
}
